import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Skipped extends QuestionPassState {
    id = QuestionPassStateId.Skipped;
    name = 'Übersprungene Fragen';
    color = '';
    orderInProgressbar = 12;
    isDefaultFiltered = true;
}
